module.exports = __webpack_public_path__ + "static/media/bd2.c4731450.jpg";